"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _callee;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _mimeWrapper = _interopRequireDefault(require("../utils/mime-wrapper"));

var _whileConnected = _interopRequireDefault(require("./effects/whileConnected"));

var _sendFiles = require("../actions/sendFiles");

var _postActivity = _interopRequireDefault(require("../actions/postActivity"));

var _marked =
/*#__PURE__*/
_regenerator["default"].mark(_callee),
    _marked2 =
/*#__PURE__*/
_regenerator["default"].mark(sendFilesToPostActivity),
    _marked3 =
/*#__PURE__*/
_regenerator["default"].mark(postActivityWithFiles);

var getType = _mimeWrapper["default"].getType.bind(_mimeWrapper["default"]);

function _callee() {
  return _regenerator["default"].wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _whileConnected["default"])(sendFilesToPostActivity);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function sendFilesToPostActivity() {
  return _regenerator["default"].wrap(function sendFilesToPostActivity$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(function (_ref) {
            var payload = _ref.payload,
                type = _ref.type;
            return type === _sendFiles.SEND_FILES && payload.files.length;
          }, postActivityWithFiles);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

function postActivityWithFiles(_ref2) {
  var files;
  return _regenerator["default"].wrap(function postActivityWithFiles$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          files = _ref2.payload.files;
          _context3.next = 3;
          return (0, _effects.put)((0, _postActivity["default"])({
            attachments: [].map.call(files, function (_ref3) {
              var name = _ref3.name,
                  url = _ref3.url;
              return {
                contentType: getType(name) || 'application/octet-stream',
                contentUrl: url,
                name: name
              };
            }),
            channelData: {
              attachmentSizes: [].map.call(files, function (_ref4) {
                var size = _ref4.size;
                return size;
              })
            },
            type: 'message'
          }));

        case 3:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}